// @ts-check
import { combineReducers } from "redux";
import { globalFormReducer } from '../../components/GlobalForm/globalFormReducer'
import { topLevelReducer } from '../../components/topLevelReducer'
import { modelReducer } from '../../components/Model/modelReducer';
import { viewControlsReducer } from '../../components/ModelControls/viewControlsReducer';
import { authReducer } from '../../components/Auth/authReducer'

const rootReducer = combineReducers({
  auth: authReducer,
  globalFormData: globalFormReducer,
  topLevel: topLevelReducer,
  model: modelReducer,
  viewControls: viewControlsReducer
});

export default rootReducer
